import api from './index';
//
let exports = {};

// 获取-源数据初始参数
exports.fetchReportInitParams = function (postData, callback) {
    api.post('/report/result/init/params/get')
    .data(postData)
    .done(callback)
    .go();
};
// 获取-源数据初始参数（包括统计列）
exports.fetchReportInitParamsX = function (postData, callback) {
    api.post('/report/result/init/paramsX/get')
    .data(postData)
    .done(callback)
    .go();
};

// 获取-源数据
exports.fetchReportResultSet = function (postData, callback) {
    api.post('/report/result/set/get')
    .data(postData)
    .done(callback)
    .go();
};

// 获取-html
exports.fetchReportResult = function (postData, callback) {
    api.post('/report/result/get')
    .data(postData)
    .done(callback)
    .go();
};

// 获取报表列数据
exports.getReportMetaColList = function (postData, callback) {
    api.post('/report/metaColList/get')
    .data(postData)
    .done(callback)
    .go();
};

// 获取-(通用报表统计 - cols, rows, total)
exports.getReportResultDatas = function (postData, callback) {
    api.post('/report/result/datas/get')
    .data(postData)
    .done(callback)
    .go();
};

// 报表导出url
exports.getReportResultExportParams = function (postData, callback) {
    api.post('/report/result/export/params/get')
    .data(postData)
    .done(callback)
    .go();
};

// 获取-表格json
exports.fetchReportResultData = function (postData, callback) {
    api.post('/report/result/get')
    .data(postData)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/easyReport.js
// module id = 43
// module chunks = 0